<!-- ------------------------------------------------------------------ -->
<!-- Delete contact -->
<!-- ------------------------------------------------------------------ -->
<h4 mat-dialog-title>Confirmation</h4>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="warn" (click)="onConfirm()">Yes</button>
  <button
    mat-stroked-button
    class="bg-error text-white"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
